var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 60V6.666c0 9.36-8.41 9.96-18.144 10.654-7.6.542-16.01 1.142-21.856 6.013V60h40Z",
    fill: "#FF002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21.25 18.75 25 25 16.25M35 20a6.244 6.244 0 0 1-2.655 5.113 6.242 6.242 0 0 1-1.738 5.494 6.242 6.242 0 0 1-5.494 1.738A6.242 6.242 0 0 1 20 35a6.244 6.244 0 0 1-5.113-2.655 6.243 6.243 0 0 1-5.494-1.738 6.242 6.242 0 0 1-1.738-5.494A6.242 6.242 0 0 1 5 20a6.244 6.244 0 0 1 2.655-5.113 6.242 6.242 0 0 1 1.738-5.494 6.243 6.243 0 0 1 5.494-1.738A6.243 6.243 0 0 1 20 5a6.244 6.244 0 0 1 5.113 2.655 6.243 6.243 0 0 1 5.494 1.738 6.244 6.244 0 0 1 1.738 5.494A6.242 6.242 0 0 1 35 20Z",
    stroke: "#FF002B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.417,
    y: 0.417,
    width: 39.167,
    height: 39.167,
    rx: 19.583,
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.833
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verification-icon.c7118274bbc64b8700638e793ca87757.svg";
export { ForwardRef as ReactComponent };